import { z } from "zod";
export const ClassifyVerdictSchema = z.enum(["EVENT", "NOT_EVENT", "UNCERTAIN"]);
export const ClassifyResultSchema = z.object({
    verdict: ClassifyVerdictSchema,
    confidence: z.number().min(0).max(100),
    categoryHint: z.string().optional(),
    reasoning: z.string().optional(),
});
//# sourceMappingURL=llm.js.map